import React, { useState } from 'react';
import { Typography } from 'fronton-react';
import { t } from 'i18next';
import { analyticsUtils } from 'utils';
import { FadeButton } from 'common/components/section-vlimit/fade-button';
import { LinkedPagesItem } from './linked-pages-item';
import { MAX_VISIBLE_LINKED_PAGES } from '../constants';
import { container, fadeButton, linkedPagesWrapper } from './styles';
import { LinkedPagesItemType } from './types';

type LinkedPagesProps = {
  pages: LinkedPagesItemType[];
};

export const LinkedPages: React.FC<LinkedPagesProps> = ({ pages }) => {
  const isLimited = pages.length > MAX_VISIBLE_LINKED_PAGES;

  const [isHidden, setIsHidden] = useState(true);

  const handleClick = () => {
    setIsHidden(!isHidden);

    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock: 'productDetail',
      elementName: `oftenSearched / ${!isHidden ? 'close' : 'open'}`,
      elementText: 'Часто ищут',
    });
  };

  return (
    <div className={container}>
      <Typography variant="s" size="body_accent" as="h3" color="text-primary">
        {t('linked-pages.often-search')}
      </Typography>
      <section className={linkedPagesWrapper} data-qa="linked-pages-wrapper">
        {pages.map(
          ({ pageUrl, names, labels }, idx) =>
            (labels || names) && (
              <LinkedPagesItem
                key={pageUrl}
                pageUrl={pageUrl}
                name={labels || names}
                idx={idx}
                isHidden={isHidden}
              />
            ),
        )}
      </section>
      {isLimited && <FadeButton open={isHidden} onClick={handleClick} className={fadeButton} />}
    </div>
  );
};
